import React, { useEffect } from 'react';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { getClickEventHandler } from 'src/commons/utils';
import didElementLoad from 'src/commons/utils/didElementLoad';
import { ActionsDropdown } from './Dropdown';
import { ActionsText } from './Text';
import { ConnectedActionsPopover as ActionsPopover } from './Popover';
import {
  Action,
  ACTION_TYPE,
  ActionInfo,
  ButtonType,
  DropdownType,
  PopoverType,
} from '../types';
import { logger } from 'src/commons/utils/logger';
import { PageHeaderBundleProvider } from 'src/providers/PantherLocalizationProvider';
import { ActionsButton } from 'src/features/header/components/PageHeader/Actions/Button';

export const Actions: React.VFC<{
  actions: ActionInfo[] | undefined;
}> = ({ actions }) => {
  useEffect(() => {
    if (actions && actions.length > 0) {
      didElementLoad('actions');
    }
  }, []);

  if (!actions) {
    return null;
  }

  return (
    <>
      {actions.map((actionTemplate) => {
        let item;
        let eventHandler;
        let action;

        switch (actionTemplate.type) {
          case ACTION_TYPE.BUTTON:
            action = actionTemplate as ButtonType;
            eventHandler = getClickEventHandler(
              action,
              AACChromeAPI.getActionEventTarget(),
            );

            item = (
              <ActionsButton
                {...action}
                onClickEvent={eventHandler}
                key={action.id}
              />
            );
            break;
          case ACTION_TYPE.DROPDOWN:
            action = actionTemplate as DropdownType;
            item = <ActionsDropdown {...action} key={action.id} />;
            break;
          case ACTION_TYPE.POPOVER:
            action = actionTemplate as PopoverType;
            item = (
              <PageHeaderBundleProvider key={action.id}>
                <ActionsPopover {...action} />
              </PageHeaderBundleProvider>
            );
            break;
          case ACTION_TYPE.TEXT:
            action = actionTemplate as Action;
            item = <ActionsText {...action} key={action.id} />;
            break;
          default:
            logger.error(
              `Unsupported Action type, returning empty item. type: ${actionTemplate.type}`,
            );
            item = null;
        }

        return item;
      })}
    </>
  );
};
